export default __webpack_public_path__ + "static/media/HSL_test_users_for_ Sandbox.a48ffd55.pdf";